<div mat-dialog-content class="dialog-container">
  <h1 class="w-100">Employer Plan Lookup</h1>
  <form #rixtremaForm class="container">
    <div class="mb-3">
      <mat-radio-group
        class="rixtrema-radio col-12"
        aria-label="Lookup Selector"
        [ngModelOptions]="{ standalone: true }"
        [(ngModel)]="searchType"
        (change)="clearData()"
      >
        <mat-radio-button class="radio-button" [value]="'name'">
          <mat-icon>topic</mat-icon>
          Employer Plan Name
        </mat-radio-button>
        <mat-radio-button class="radio-button" [value]="'sponsor'">
          <mat-icon>location_city</mat-icon>
          Sponsor
        </mat-radio-button>
        <mat-radio-button class="radio-button" [value]="'ein'">
          <mat-icon>pin</mat-icon>
          EIN
        </mat-radio-button>
        <mat-radio-button class="radio-button" [value]="'zip'">
          <mat-icon>mail</mat-icon>
          ZIP Code
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="row">
      <div class="col-10 search-fields">
        @if (searchType === 'name') {
          <mat-form-field class="col-12">
            <mat-label>
              {{ fieldText }}
            </mat-label>
            <input
              matInput
              id="rixtrema-search"
              name="searchTerm"
              [ngModelOptions]="{ standalone: true }"
              [placeholder]="fieldText"
              [(ngModel)]="searchTerm"
              (keydown.enter)="$event.preventDefault()"
              (keyup.enter)="search(); $event.preventDefault()"
            />
          </mat-form-field>
        }
        @if (searchType === 'sponsor') {
          <mat-form-field class="col-12">
            <mat-label>Sponsor</mat-label>
            <input
              matInput
              id="rixtrema-sponsor"
              placeholder="Sponsor"
              label="Sponsor"
              name="sponsor"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="sponsor"
              (keydown.enter)="$event.preventDefault()"
              (keyup.enter)="search(); $event.preventDefault()"
            />
          </mat-form-field>
        }
        @if (searchType === 'ein') {
          <mat-form-field class="col-12">
            <mat-label>EIN</mat-label>
            <input
              matInput
              id="ein"
              placeholder="EIN"
              label="EIN"
              name="ein"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="ein"
              (keydown.enter)="$event.preventDefault()"
              (keyup.enter)="search(); $event.preventDefault()"
            />
          </mat-form-field>
        }
        @if (searchType === 'zip') {
          <mat-form-field class="col-6">
            <mat-label>Employer Plan Name</mat-label>
            <input
              matInput
              id="rixtrema-search"
              placeholder="Employer Plan Name"
              label="Employer Plan Name"
              name="zipName"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="zipName"
              (keydown.enter)="$event.preventDefault()"
              (keyup.enter)="search(); $event.preventDefault()"
            />
          </mat-form-field>
          <mat-form-field class="col-3">
            <mat-label>ZIP</mat-label>
            <input
              matInput
              id="rixtrema-zip"
              placeholder="ZIP"
              label="ZIP"
              name="zip"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="zip"
              (keydown.enter)="$event.preventDefault()"
              (keyup.enter)="search(); $event.preventDefault()"
            />
          </mat-form-field>
          <mat-form-field class="col-3">
            <mat-label>Distance (miles)</mat-label>
            <input
              matInput
              id="rixtrema-distance"
              placeholder="Distance (miles)"
              label="Distance (miles)"
              name="distance"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="distance"
              (keydown.enter)="$event.preventDefault()"
              (keyup.enter)="search(); $event.preventDefault()"
            />
          </mat-form-field>
        }
      </div>
      <div class="col-2">
        <button
          type="button"
          mat-raised-button
          color="accent"
          [disabled]="!searchValid()"
          (click)="search(); $event.preventDefault()"
        >
          <mat-icon>search</mat-icon>
          Search
        </button>
      </div>
    </div>

    <div class="results-container">
      @if (plans && plans.length > 0) {
        <h4 class="mt-3">Search Results</h4>
        <div class="table-wrapper">
          <table class="results-table">
            <thead>
              <th>Employer Plan Name</th>
              <th>Sponsor</th>
              <th>EIN</th>
              <th>ZIP</th>
              <th>Admin Fee</th>
              <th>Participants</th>
            </thead>
            <tbody>
              @for (plan of plans; track plan) {
                <tr
                  [ngClass]="{ selected: plan === selectedPlan }"
                  (click)="planSelect(plan)"
                >
                  <td>
                    @if (plan === selectedPlan) {
                      <mat-icon>check_circle</mat-icon>
                    }
                    {{ plan['PLAN_NAME'] }}
                  </td>
                  <td>{{ plan['SPONSOR_DFE_NAME'] }}</td>
                  <td>{{ plan['SPONSOR_EIN'] }}</td>
                  <td>{{ plan['Zip'] }}</td>
                  <td>{{ plan['AdminExpRate'] / 100 | percent: '1.3' }}</td>
                  <td>{{ plan['TOT_ACTIVE_PARTCP_CNT'] | number }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
      @if (resultsMessage) {
        <div>
          <h4>{{ resultsMessage }}</h4>
        </div>
      }
      @if (UnitInfo?.ShowF5500Help) {
        <div class="search-help-text-container">
          <div>
            Tip: To pre-fill employer plan information, please search the 5500
            database, which offers details specific to the plan being moved.
          </div>
          <div>
            Tip: For better results, keep your search simple. For example, type
            'IBM' instead of 'IBM 401k plan.'
          </div>
        </div>
      }
    </div>
  </form>
</div>
<div mat-dialog-actions class="actions">
  @if (
    showRlc &&
    (selectedPlan !== null || (subplanID !== '' && subplanID !== null))
  ) {
    <button
      type="button"
      mat-raised-button
      [disabled]="subplanID === '' || subplanID === null"
      (click)="getPdf()"
    >
      <mat-icon>insert_drive_file</mat-icon>Download RLC Fact Sheet
    </button>
  }
  @if (!showRlc && rlcAccess) {
    <button
      type="button"
      mat-raised-button
      [disabled]="true"
      (click)="getPdf()"
    >
      <mat-icon>insert_drive_file</mat-icon>RLC Factsheet Unavailable
    </button>
  }
  @if (showRlc && subplanID === '' && selectedPlan !== null) {
    <button
      type="button"
      mat-raised-button
      [disabled]="true"
      (click)="getPdf()"
    >
      <mat-icon>insert_drive_file</mat-icon>Select Sub-Plan
    </button>
  }
  @if (!rlcAccess) {
    <button
      type="button"
      mat-raised-button
      [disabled]="selectedPlan === null"
      (click)="getFactsheet()"
    >
      <mat-icon>insert_drive_file</mat-icon> Download F5500 Fact Sheet
    </button>
  }
  @if (showSubplanSelect && rlcAccess && selectedPlan !== null) {
    <form #planForm>
      <div>
        <mat-form-field class="col-12">
          <mat-label>Sub-Plan</mat-label>
          <select
            matNativeControl
            id="rixtrema-subplanID"
            name="PDF"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="subplanID"
          >
            @for (pdf of selectedPlanData.pdfs; track pdf) {
              <option [value]="pdf.PathFilename">
                {{ pdf.PlanName }}
              </option>
            }
          </select>
        </mat-form-field>
      </div>
    </form>
  }
  @if (!data.dataF5500) {
    <button
      type="button"
      mat-button
      color="warn"
      class="mx-2"
      (click)="close(); $event.preventDefault()"
    >
      Cancel
    </button>
    <div
      matTooltip="Please perform a search before using manual entry."
      [matTooltipDisabled]="!checkICantFindItDisabled()"
    >
      <button
        type="button"
        mat-stroked-button
        color="primary"
        class="mx-2"
        [disabled]="checkICantFindItDisabled()"
        (click)="noneFound(); $event.preventDefault()"
      >
        <mat-icon>troubleshoot</mat-icon> I Can't Find It
      </button>
    </div>
  }
  <button
    type="button"
    mat-raised-button
    color="accent"
    class="mx-2"
    [disabled]="selectedPlanData === null"
    (click)="save(); $event.preventDefault()"
  >
    <mat-icon>check</mat-icon> Use This One
  </button>
</div>
<ngx-loading [show]="loading" />
